module.exports = __webpack_public_path__ + "media/react/gre/adaptive_prep_v2/assets/single_diamond-599ff8f895441a313280e09fbbaa6b81.svg";